var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cancelAllShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "cancelAll" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("language.popup.cancel")))]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.closePage()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-content" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("language.popup.cloudExploerPopup.cancelAllTask"))
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-all-footer" }, [
            !_vm.loading
              ? _c(
                  "button",
                  {
                    staticStyle: { float: "right", "min-width": "82Px" },
                    on: {
                      click: function($event) {
                        return _vm.cancelAll()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.popup.cancel")))
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loading
              ? _c(
                  "button",
                  { staticStyle: { float: "right", "min-width": "82Px" } },
                  [
                    _c("span", {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ]
                    })
                  ]
                )
              : _vm._e()
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e25af92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e25af92","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/cancel_all_popup.vue
// module id = null
// module chunks = 